import React, { useState, useEffect } from "react"
import styles from './JackpotHitAnimation.module.css'


import { useAppContext } from "../../stores/appStore"

function JackpotHitAnimation() {
    const { jackpotHit } = useAppContext()
    const [show, setShow] = useState(false)


    useEffect(() => {
        if (jackpotHit) {
            setShow(true)
            setTimeout(() => {
                setShow(false)
            }, 10000);
        }
    }, [jackpotHit])



    return (
        <div className={`${styles.wrapper} ${show && styles.show}`}>
           <div className={styles.astro}></div>
           <div className={styles.text}>JACKPOT</div>
        </div>
    )
}

export default JackpotHitAnimation
